import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-file-url-modal',
  templateUrl: './file-url-modal.component.html',
  styleUrls: ['./file-url-modal.component.scss']
})
export class FileUrlModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<FileUrlModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) { }

  ngOnInit(): void {
  }

}
